import {Component, Inject, Input, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {UserObject} from '@iana-rzms/bff-sdk';
import {UserService} from "../../../services/user.service";

@Component({
    selector: 'communications-settings',
    templateUrl: './communications-settings.component.html',
    styleUrls: ['./communications-settings.component.scss'],
    standalone: false
})
export class CommunicationsSettingsComponent implements OnInit {
  @Input()
  user: UserObject;

  communicationsForm: FormGroup;
  modified = false;
  isStaffUI: boolean;

  constructor(private formBuilder: FormBuilder,
              private userService: UserService,
              @Inject('env') private environment) {
  }

  cancel() {
    this.initForm();
  }

  onSubmit() {
    if (this.isStaffUI) {
      return;
    }
    this.userService.updateCommunicationSettings(
      this.user.id,
      true,
      !!this.communicationsForm.getRawValue().product,
      !!this.communicationsForm.getRawValue().security)
      .subscribe(data => {
        this.modified = false;
      });
  }

  ngOnInit(): void {
    this.isStaffUI = this.environment.config.interfaceType === 'STAFF';
    this.initForm();
  }

  private initForm() {
    this.modified = false;
    this.communicationsForm = this.formBuilder.group({
      operation: new FormControl({value: true, disabled: true}, []),
      product: new FormControl(this.isStaffUI ? {value: true, disabled: true} : true, []),
      security: new FormControl(this.isStaffUI ? {value: true, disabled: true} : true, []),
    });
    if (!this.user) {
      this.userService.getCurrentUser().subscribe((data: UserObject) => {
        this.user = data;
        this.setFormValuesFromUser();
      });
    } else {
      this.setFormValuesFromUser();
    }
  }
  private setFormValuesFromUser() {
    if (this.user.communicationPreferences?.operational_alerts === false) {
      this.communicationsForm.controls['operation'].patchValue({value: false, disabled: true});
    }
    if (this.user.communicationPreferences?.feature_updates === false) {
      this.communicationsForm.controls['product'].patchValue(this.isStaffUI ? {value: false, disabled: true} : false);
    }
    if (this.user.communicationPreferences?.technical_alerts === false) {
      this.communicationsForm.controls['security'].patchValue(this.isStaffUI ? {value: false, disabled: true} : false);
    }
  }
}
